export default __webpack_public_path__ + "static/media/connected-world-rafiki.5d64a53a.svg";